import { jsxs, jsx } from "react/jsx-runtime";
const DotSelected = () => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    viewBox: "0 0 16 16",
    children: [
      /* @__PURE__ */ jsx("mask", { id: "dotSelected", fill: "#fff", children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          d: "M14.4 8A6.4 6.4 0 1 1 1.6 8a6.4 6.4 0 0 1 12.8 0",
          clipRule: "evenodd"
        }
      ) }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#707070",
          fillRule: "evenodd",
          d: "M14.4 8A6.4 6.4 0 1 1 1.6 8a6.4 6.4 0 0 1 12.8 0",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#5F5F5F",
          d: "M13.4 8A5.4 5.4 0 0 1 8 13.4v2A7.4 7.4 0 0 0 15.4 8h-2ZM8 13.4A5.4 5.4 0 0 1 2.6 8h-2A7.4 7.4 0 0 0 8 15.4v-2ZM2.6 8A5.4 5.4 0 0 1 8 2.6v-2A7.4 7.4 0 0 0 .6 8h2ZM8 2.6A5.4 5.4 0 0 1 13.4 8h2A7.4 7.4 0 0 0 8 .6v2Z",
          mask: "url(#dotSelected)"
        }
      )
    ]
  }
);
export {
  DotSelected
};
